import template from './bedrooms-count.jade';
import validation from '../../../services/validation';

export default angular
    .module('cian.addForm.bedroomsCount', [])
    .directive('cianAfAboutObjectBedroomsCount', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['deviceService', function (deviceService) {
            this.isMobile = deviceService.isMobile;
            this.countMin = 0;
            this.countMax = 999;

            this.validation = validation(this.form, 'bedroomsCount', {
                parse: 'Введите число',
                min: 'Количество спален не может быть отрицательным',
                max: 'Допустимо не более 3 символов',
            });
        }],
        controllerAs: 'bedroomsCount',
        template,
    }))
    .name;
